var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('div',{staticClass:"text-h4 white--text"},[_vm._v("404. That's an error.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }